<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Exam Live Dashboard</span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="card">
            <v-card-title class="heading">Exam Live Dashboard</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">Date</label>
                        <p class="value">{{start_date}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">Start Time</label>
                        <p class="value">{{starttime}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">End Time</label>
                        <p class="value">{{endtime}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <!-- <v-text-field label="Remaining Time(minutes)" v-model="remtime" readonly></v-text-field> -->
                        <label class="label">Remaining Time(minutes)</label>
                        <p class="value">{{remtime}}</p>
                    </v-col>
                </v-row>
                <!-- Vrushali Code Start -->
                <v-row class="heading">
                    <v-col cols="12" sm="2" md="2">
                        <span>Refresh</span>
                        <v-icon color="white" @click="refreshTable">mdi-refresh-circle</v-icon>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <strong>
                            <h3>Total Student :: {{course_off_learner}}</h3>
                        </strong>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <strong>
                            <h3>Present Students :: {{all_learner_data}}</h3>
                        </strong>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <strong>
                            <h3>
                                Absent Students :: <span class="abstud" @click="displaydata()"><a
                                        class="textcolor">{{absent_learner_data}}</a></span>
                            </h3>
                        </strong>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-dialog v-model="dialog_ab_stud" scrollable max-width="1000px">
                <v-card>
                    <center class="heading"><strong>Absent Student Details</strong></center>
                    <v-card>
                        <v-col cols="12" sm="12" md="12">
                            <download-excel :data="absent_learner_data_details" worksheet="absent_learner_data_details"
                                :fields="exam_absent_list" name="Absent_Student_list.xls">
                                <v-btn color="success" class="ma-2 white--text downbtn">
                                    <v-icon left dark>mdi-file-excel</v-icon>
                                    export xls
                                </v-btn>
                            </download-excel>
                            <v-data-table :headers="headers_abb" :items="absent_learner_data_details" sort-by
                                class="elevation-1 mytable" :search="search">
                            </v-data-table>
                        </v-col>
                        <v-card-actions class="justify-center">
                            <v-btn class="button" text @click="dialog_ab_stud = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>
            <!-- Vrushali Code End -->
            <v-row class="box">
                <v-col cols="12" lg="6">
                    <v-row justify="center" class="inner-box">
                        <v-col cols="12" lg="6">
                            <v-text-field solo dense label="Extra Time(In Minutes) " v-model="extratime"></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <!-- <input type="hidden" v-model="exam_id" name="exam_id" /> -->
                            <v-btn rounded color="info" v-model="updatetoalltime" @click="updatExtraTimeForAll()">Update
                                To All</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row justify="center" class="inner-box">
                        <v-col cols="12" lg="6">
                            <v-autocomplete label="Exam Status" :items="examstatuslist" item-text="name" item-value="id"
                                solo dense v-model="examstatuslist1" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <input type="hidden" v-model="exam_id" name="exam_id" />
                            <v-btn rounded color="info" v-model="examstatus"
                                @click="updatStstusForAll(examstatuslist1)">Update To All</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- <v-simple-table class="table-data" v-if="examlearnerlist!=null">
            <template v-slot:default>
               <thead >
                  <tr>
                  </tr>
                  <br />
                  <tr >
                     <th class="text-left">Sr.No</th>
                     <th class="text-left">Student Name</th>
                     <th class="text-left">Start Time</th>
                     <th class="text-left">End Time</th>
                     <th class="text-left">IP Address</th>
                     <th class="text-left">Remaining Time (in minutes)</th>
                     <th style="width:50%; white-space: nowrap;">Update Extra Time</th>
                     <th style="width:70%; white-space: nowrap;"></th>
                     <th style="width:80%; white-space: nowrap;">Update Current Status</th>
                     <th class="text-left"></th>
                     <th class="text-left" style="white-space: nowrap;">View Proctoring Logs</th>
                     <th style="width:95%; white-space: nowrap;">Update Proctoring Status</th>
                     <th style="width:70%;"><v-icon class="reload" @click="refreshTable">mdi-refresh-circle</v-icon></th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="item in examlearnerlist" :key="item.id">
                     <td>{{ item.srno }}</td>
                     <td>{{ item.grno }}</td>
                     <td>{{ item.started_at }}</td>
                     <td>{{ item.end_time }}</td>
                     <td>{{ item.ipaddress }}</td>
                     <td>{{ item.remaining_time}}</td>
                     <td style="padding: 20px 0px 0px 0px;">
                        <v-text-field  outlined dense v-model="item.extra" style="width:auto;"></v-text-field>
                        
                     </td>
                     <td style="padding:0px 0px 10px 10px">
                        <v-btn  small rounded v-model="item.Update" class="button" @click="updaterow(item)">Update</v-btn>
                     </td>
                     
                     <td style="width:80%; white-space: nowrap;">
                        <v-autocomplete
                           :items="examstatuslist"
                           outlined
                           dense
                           style="width:140px;padding-top: 20px;" 
                           item-text="name"
                           item-value="id"
                           v-model="item.status_id"
                           persistent-hint
                           >
                        </v-autocomplete>
                     </td>
                     <td style="padding: 0px 0px 10px 0px;">
                        <v-btn class="button" v-model="item.status" small rounded @click="updateLesrowExamStatus(item)" >Update</v-btn>
                     </td>
                     <td style="text-align: center;color: #5cbbf6;">
                        <i class="mdi mdi-eye eye" @click="viewAllPhoto(item)"></i>
                     </td>
                     <td style="width:80%; white-space: nowrap;">
                        <v-autocomplete
                           :items="procstatus"
                           outlined
                           dense
                           style="width:130px;padding-top: 20px;" 
                           item-text="name"
                           item-value="id"
                           v-model="item.proctor_id"
                           persistent-hint
                           ></v-autocomplete>
                     </td>
                     <td style="padding: 0px 0px 10px 0px;">
                        <v-btn class="button" v-model="item.status" small rounded @click="updateLesrowProctorStatus(item)">Update</v-btn>
                     </td>
                  </tr>
               </tbody>
            </template>
         </v-simple-table> -->
            <template>
                <!-- By vrushali geo loaction config wise if else condition to datatable -->
                <v-toolbar flat color="white">
                    <v-toolbar-title></v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <download-excel class="mar" :data="examlearnerlist" :fields="table_fields"
                        worksheet="examlearnerlist" name="examlearnerlist.xls">
                        <v-btn color="success" dark class="mb-2"> Export<v-icon dark>mdi-file-excel</v-icon> </v-btn>
                    </download-excel>
                </v-toolbar>
                <v-data-table :search="search1" v-if="geolocation_config == true" :headers="newHeaders"
                    :items="examlearnerlist" :expanded.sync="expanded" :single-expand="singleExpand" item-key="srno"
                    show-expand class="elevation-1 table-data">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>

                            <div style="text-align: center;">
                                <div>
                                    <span class="refresh">Refresh Live data</span>
                                </div>
                                <div>
                                    <v-icon style="font-size: 35px; color: #5cbbf6;"
                                        @click="refreshTable">mdi-refresh-circle</v-icon>
                                </div>
                            </div>
                            <!-- <v-icon style="font-size:35px; color: #5cbbf6;" @click="refreshTable">mdi-refresh-circle</v-icon> -->
                            <!-- <v-btn @click="refreshTable" class="button">Refresh</v-btn> -->
                            <v-spacer></v-spacer>
                            <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.log="{ item }">
                        <i class="mdi mdi-eye eye" style="text-align: center; color: #5cbbf6;"
                            @click="viewAllPhoto(item)"></i>
                    </template>
                    <template v-slot:item.limit_cross_remark="{ item }">
                        <span v-if="item.tab_limit_cross_remark">
                            <i class="mdi mdi-check" style="text-align: center; color: green;font-size:25px;"></i>
                        </span>
                        <span v-else>
                            <i class="mdi mdi-close" style="text-align: center; color: red;font-size:25px;"></i>
                        </span>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" style="padding-left: 30px;">
                            <v-row>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Extra Time</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-text-field outlined dense v-model="item.extra"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn small rounded v-model="item.Update" class="button"
                                                @click="updaterow(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Current Status</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-autocomplete :items="examstatuslist" outlined dense style="width: 140px;"
                                                item-text="name" item-value="id" v-model="item.status_id"
                                                persistent-hint> </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn class="button" v-model="item.status" small rounded
                                                @click="updateLesrowExamStatus(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Proctoring Status</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-autocomplete :items="procstatus" outlined dense style="width: 130px;"
                                                item-text="name" item-value="id" v-model="item.proctor_id"
                                                persistent-hint></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn class="button" v-model="item.status" small rounded
                                                @click="updateLesrowProctorStatus(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </td>
                    </template>
                </v-data-table>
                <v-data-table :search="search1" v-else :headers="newHeaders1" :items="examlearnerlist"
                    :expanded.sync="expanded" :single-expand="singleExpand" item-key="srno" show-expand
                    class="elevation-1 table-data">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>

                            <div style="text-align: center;">
                                <div>
                                    <span class="refresh">Refresh Live data</span>
                                </div>
                                <div>
                                    <v-icon style="font-size: 35px; color: #5cbbf6;"
                                        @click="refreshTable">mdi-refresh-circle</v-icon>
                                </div>
                            </div>
                            <!-- <v-icon style="font-size:35px; color: #5cbbf6;" @click="refreshTable">mdi-refresh-circle</v-icon> -->
                            <!-- <v-btn @click="refreshTable" class="button">Refresh</v-btn> -->
                            <v-spacer></v-spacer>
                            <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.log="{ item }">
                        <i class="mdi mdi-eye eye" style="text-align: center; color: #5cbbf6;"
                            @click="viewAllPhoto(item)"></i>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" style="padding-left: 30px;">
                            <v-row>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Extra Time</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-text-field outlined dense v-model="item.extra"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn small rounded v-model="item.Update" class="button"
                                                @click="updaterow(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Current Status</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-autocomplete :items="examstatuslist" outlined dense style="width: 140px;"
                                                item-text="name" item-value="id" v-model="item.status_id"
                                                persistent-hint> </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn class="button" v-model="item.status" small rounded
                                                @click="updateLesrowExamStatus(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <p class="ex-text">Update Proctoring Status</p>
                                    <v-row>
                                        <v-col cols="12" lg="6">
                                            <v-autocomplete :items="procstatus" outlined dense style="width: 130px;"
                                                item-text="name" item-value="id" v-model="item.proctor_id"
                                                persistent-hint></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="6" class="pl-0">
                                            <v-btn class="button" v-model="item.status" small rounded
                                                @click="updateLesrowProctorStatus(item)">Update</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </td>
                    </template>
                </v-data-table>
            </template>
        </v-card>
        <!-- <v-card class="mx-auto">
         <v-card-title>
             <span>Exam Live Dashboard</span>
             <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
         </v-card-title><br>
         <v-card-text>-->
        <!--<p v-for="data in examlearnerlist" :key="data">
         <ul>
         <li v-for="ph in data.Photo" :key="ph">
             <a v-bind:href="ph.photopath">view</a>
         </li>
         </ul>
         </p>-->
        <!-- <div v-if="examlearnerlist" class="mx-auto container container--fluid">
         <v-data-table :headers="headers1" :items="examlearnerlist" :search="search">
             <template v-slot:item.action1="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon> 
                  <v-btn class="ma-2" :loading="loading4" :disabled="loading4" color="info"  @click="proceed(item.id)" v-model="details_id" >Proceed
                  </v-btn>
             </template>
          <template v-slot:item.extra="{item }">
           <v-text-field solo dense v-model="item.extra" ></v-text-field>
         </template>
         
          <template v-slot:item.status="{item}">
           <v-select label="Status" :items="examstatuslist" solo dense item-text="name" item-value="id" v-model="item.status" persistent-hint></v-select>
           <v-btn  color="info" v-model="item.status"  @click="updaterow(item)" >Update</v-btn>
         </template>
             
          <template v-slot:item.Photo ="{ item }">
                 <v-btn  color="info" v-model="item.procstatus" @click="viewAllPhoto(item)" >View</v-btn>
         </template>
         
         <template v-slot:item.procstatus="{item}">
         <v-select label="Status" :items="procstatus" solo dense item-text="name" item-value="id" v-model="item.procstatus" persistent-hint></v-select>
         <v-btn  color="info" v-model="item.procstatus" @click="updaterow(item)" >Update</v-btn>
         </template>
         <template v-slot:item.Update="{item}">
             <v-btn  color="success" v-model="item.Update" @click="updaterow(item)" >Update</v-btn>
         </template>
         
         </v-data-table>   
         </v-card-text>
         </v-card>
         </div>-->

        <v-row justify="center">
            <v-dialog v-model="dialog_zooimg" persistent max-width="600px">
                <v-card>
                    <br />
                    <v-card-title>
                        <span class="headline">Image Pre-View</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <img class="question-img rounded w-100 d-block imgs-preview" :src="img_url" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-row>
                            <v-btn color="error" class="justify-center" rounded
                                @click="dialog_zooimg = false">Close</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="dialog_allPhoto" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="all-pic">
                        <v-btn icon dark @click="dialog_allPhoto = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Photos</v-toolbar-title>
                        <v-spacer></v-spacer>
                        {{student}}
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_allPhoto = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-row>
                        <v-data-table :headers="headers1" :items="proctorloglist" :search="search"
                            disable-pagination="true">
                            <template v-slot:item.isweirdsounddected="{ item }">
                                <span v-if="item.isweirdsounddected == true">
                                    <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.isimageattached="{ item }">
                                <span v-if="item.isimageattached == true">
                                    <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.isoutofframedetected="{ item }">
                                <span v-if="item.isoutofframedetected == true">
                                    <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.ismorethanonepersondetected="{ item }">
                                <span v-if="item.ismorethanonepersondetected == true">
                                    <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.isabnormal="{ item }">
                                <span v-if="item.isabnormal == true">
                                    <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                </span>
                            </template>
                            <template v-slot:item.photopath="{ item }">
                                <span v-if="item.photopath">
                                    <img v-bind:src="item.photopath" @click="zooimg(item.photopath)" height="100px"
                                        width="100px" />
                                </span>
                            </template>

                        </v-data-table>
                        <!-- <v-col sm="2" v-for="ph in photoPath" :key="ph">
                     <img v-bind:src="ph" height="100px" width="100px" />
                     </v-col> -->
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
        <div class="text-center" v-if="loading4">
            <v-progress-circular v-model="loading4" :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dialog_zooimg: false,
            img_url: "",
            allPhoto: null,
            photoPath: [],
            dialog_allPhoto: false,
            loading4: false,
            details_id: "",
            start_date: "",
            starttime: "",
            endtime: "",
            extratime: null,
            examstatuslist: "",
            extra: "",
            status: "",
            logs: "",
            procstatus: "",
            remtime: "",
            Update: "",
            updatetoalltime: "",
            updatetoallstatus: "",
            exam_id: "",
            examstatus: "",
            expanded: [],
            singleExpand: false,
            search1: "",
            dialog_ab_stud: false,
            newHeaders1: [
                { text: "SrNo", value: "srno" },
                { text: "Student Name", value: "grno" },
                { text: "Start Time", value: "started_at" },
                { text: "End Time", value: "end_time" },
                { text: "Student End Time", value: "exam_end_time" },
                { text: "Proctor Name", value: "proctor_name" },
                { text: "Ip Address", value: "ipaddress" },
                { text: "Remaining Time(minutes)", value: "remaining_time" },
                { text: "View Proctoring Logs", value: "log" },
                { text: "", value: "" },
            ],
            table_fields: {
                "Sr.No.": "srno",
                "Student Name": "grno",
                "Start Time": "started_at",
                "End Time": "end_time",
                "Student End Time": "exam_end_time",
                "Proctor Name": "proctor_name",
                "Ip Address": "ipaddress",
                "Remaining Time(minutes)": "remaining_time",
            },

            newHeaders: [
                { text: "SrNo", value: "srno" },
                { text: "Student Name", value: "grno" },
                { text: "Exam Start Time", value: "start_time" },
                { text: "Student Start Time", value: "started_at" },
                { text: "End Time", value: "end_time" },
                { text: "Student End Time", value: "exam_end_time" },
                { text: "Proctor Name", value: "proctor_name" },
                { text: "Ip Address", value: "ipaddress" },
                { text: "Latitude", value: "latitude" },
                { text: "Longitude", value: "longitude" },
                { text: "Remaining Time(minutes)", value: "remaining_time" },
                { text: "View Proctoring Logs", value: "log" },
                { text: "Tab Switch Count", value: "tabSwitchCount" },
                { text: "Tab Switch Limit Exeed", value: "limit_cross_remark" },

            ],
            headers1: [
                { text: "Sr.No", value: "srno" },
                { text: "Proctoring Type", value: "proctortype" },
                { text: "Captured Date", value: "captureddatetime" },
                { text: "Is Weird Sound Detected", value: "isweirdsounddected" },
                { text: "Is Image Matched", value: "isimageattached" },
                { text: "Is Out Of Frame Detceted", value: "isoutofframedetected" },
                { text: "Is More Than 1 Person Detected", value: "ismorethanonepersondetected" },
                { text: "Is Abnormal", value: "isabnormal" },
                { text: "Photo", value: "photopath" },
            ],
            headers_abb: [
                { text: "Sr.No.", value: "srno" },
                { text: "Exam", value: "exam" },
                { text: "Exam Date", value: "examdate" },
                { text: "Exam Slot", value: "exam_slot" },
                { text: "Program", value: "program" },
                { text: "Program Type", value: "programtype" },
                { text: "Course Code", value: "course_code" },
                { text: "Course Name", value: "course_name" },
                { text: "Year", value: "year" },
                { text: 'Seat No', value: 'seat_no' },
                { text: "Registration No.", value: "registration_number" },
                { text: "Name", value: "name" },
                { text: "Email", value: "email" },
            ],
            exam_absent_list: {
                "Sr. No.": "srno",
                "Exam": "exam",
                "Exam Date": "examdate",
                "Exam Slot": "exam_slot",
                "Program Type": "programtype",
                "Program": "program",
                "Course Code": "course_code",
                "Course Name": "course_name",
                "Year": "year",
                "Seat No": "seat_no",
                "Registration No.": "registration_number",
                "Name": "name",
                "Email": "email"
            },
            exam_list: "",
            exam_deatils: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            exam_summary_list: "",
            examlearnerlist: [],
            search: "",
            proctorloglist: "",
            student: null,
            //vrushali
            course_off_learner: "",
            all_learner_data: "",
            absent_learner_data: "",
            absent_learner_data_details: "",
            geolocation_config: false,
        }),
        mounted() {
            this.proceed();
        },
        methods: {
            zooimg(url_img) {
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            displaydata() {
                // alert("in display data")
                this.dialog_ab_stud = true;
            },
            refreshTable() {
                //alert("Reload Table")
                this.proceed();
            },
            updateLesrowProctorStatus(item) {
                const formData = {
                    lesid: item.id,
                    proctorstatus: item.proctor_id,
                    examtt: this.$store.getters.exam_id,
                    // program_id: this.$store.getters.program_id,
                    // program_type_id: this.$store.getters.program_type_id,
                    // year_id: this.$store.getters.year_id,
                };
                axios
                    .post("ExamLiveDashbord/updateLesrowProctorStatus", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            Object.assign((this.examlearnerlist = res.data.Exam_Details_List));
                            this.showSnackbar("#4caf50", "Proctor Status Updated Successfully....");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = true;
                    });
            },
            updateLesrowExamStatus(item) {
                const formData = {
                    lesid: item.id,
                    examstatus: item.status_id,
                    examtt: this.$store.getters.exam_id,
                    // program_id: this.$store.getters.program_id,
                    // program_type_id: this.$store.getters.program_type_id,
                    // year_id: this.$store.getters.year_id,
                };
                axios
                    .post("ExamLiveDashbord/updateLesrowExamStatus", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            Object.assign((this.examlearnerlist = res.data.Exam_Details_List));
                            this.showSnackbar("#4caf50", "Exam Status Updated Successfully....");
                        } else if (res.data.msg == "No") {
                            Object.assign((this.examlearnerlist = res.data.lesummary_data));
                            this.showSnackbar("#b71c1c", "Proctor Cannot Change Status To Initiated Or Completed......");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = true;
                    });
            },

            viewAllPhoto(item) {
                const log_id = {
                    id: item.id,
                };
                //   alert("log_id:"+log_id)
                axios
                    .post("ExamLiveDashbord/getproctorlogs", log_id)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.proctorloglist = res.data.temp;
                            this.student = item.grno
                            this.dialog_allPhoto = true;
                        } else {
                            this.loading4 = false;
                            this.showSnackbar("#b71c1c", "Exam Has Not Started Yet....");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = false;
                    })
                    .finally(() => {
                        var loading4 = false;
                    });
            },
            proceed() {
                if (this.$store.getters.exam_id == null) {
                    // alert('exam_id id not passed')
                    this.$router.push({ name: "coe-live-dashbord" });
                }
                const formData = {
                    examtt: this.$store.getters.exam_id,
                    // program_id: this.$store.getters.program_id,
                    // program_type_id: this.$store.getters.program_type_id,
                    // year_id: this.$store.getters.year_id,
                };
                (this.loading4 = true),
                    axios
                        .post("ExamLiveDashbord/getlearnerExamDetails", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.geolocation_config == "YES") {
                                    this.geolocation_config = true
                                }
                                else {
                                    this.geolocation_config = false
                                }
                                this.examlearnerlist = res.data.Exam_Details_List;
                                this.start_date = res.data.examdate;
                                this.starttime = res.data.examstarttime;
                                this.endtime = res.data.examendtime;
                                this.examstatuslist = res.data.examststatuslist;
                                this.examstatuslist1 = res.data.examststatuslist;
                                this.procstatus = res.data.procststatuslist;
                                this.remtime = res.data.remtime;
                                this.exam_id = res.data.exam;
                                this.loading4 = false;

                                //vrushali code
                                this.course_off_learner = res.data.course_off_learner;
                                this.all_learner_data = res.data.all_learner_data.length;
                                this.absent_learner_data = res.data.course_off_learner - res.data.all_learner_data.length;
                                this.absent_learner_data_details = res.data.absent_learner_data;
                                //console.log(this.absent_learner_data)
                            } else {
                                this.loading4 = false;
                                this.showSnackbar("#b71c1c", "Exam Has Not Started Yet....");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loading4 = false;
                        })
                        .finally(() => {
                            var loading4 = false;
                        });
            },

            updaterow(item, event) {
                this.loading4 = true;
                const formData = {
                    lesid: item.id,
                    extra: item.extra,
                    examtt: this.$store.getters.exam_id,
                    // program_id: this.$store.getters.program_id,
                    // program_type_id: this.$store.getters.program_type_id,
                    // year_id: this.$store.getters.year_id,
                };
                axios
                    .post("ExamLiveDashbord/updateLearnerExamSummaryRow", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            Object.assign((this.examlearnerlist = res.data.Exam_Details_List));
                            this.loading4 = false;
                            this.showSnackbar("#4caf50", "Updated Successfully....");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = true;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            updatExtraTimeForAll() {
                // alert("data...."+this.extratime)
                this.loading4 = true;
                if (this.extratime == null) {
                    this.showSnackbar("#b71c1c", "Enter Extra Time...");
                } else {
                    const formData = {
                        extratime: this.extratime,
                        examid: this.exam_id,
                        examtt: this.$store.getters.exam_id,
                        // program_id: this.$store.getters.program_id,
                        // program_type_id: this.$store.getters.program_type_id,
                        // year_id: this.$store.getters.year_id,
                    };
                    axios
                        .post("ExamLiveDashbord/updatExtraTimeForAll", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign((this.examlearnerlist = res.data.Exam_Details_List));
                                //alert("in function...")
                                this.loading4 = false;
                                this.showSnackbar("#4caf50", "Extra Time Updatedto all Successfully....");
                                this.extratime = null;
                                this.proceed();
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loading4 = true;
                        });
                }
            },
            updatStstusForAll(item) {
                //alert("item...."+item)
                //alert("data...."+this.examstatus)
                this.loading4 = true;
                if (this.examstatus == null) {
                    this.showSnackbar("#b71c1c", "Select Exa Status.....");
                } else {
                    const formData = {
                        examstatus: item,
                        examid: this.exam_id,
                        examtt: this.$store.getters.exam_id,
                        // program_id: this.$store.getters.program_id,
                        // program_type_id: this.$store.getters.program_type_id,
                        // year_id: this.$store.getters.year_id,
                    };
                    axios
                        .post("ExamLiveDashbord/updatStatusForAll", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign((this.examlearnerlist = res.data.Exam_Details_List));
                                this.loading4 = false;
                                this.showSnackbar("#4caf50", "Status for all Updated Successfully....");
                                this.examstatus = "";
                                this.status = "";
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loading4 = true;
                        });
                }
            },
        },
    };
</script>
<style scoped>
    .refresh {
        font-size: 11px;
        color: green;
    }

    .ex-text {
        font-weight: 500;
        margin-bottom: 0px;
    }

    .elevation-1 /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        /* white-space: nowrap !important; */
    }

    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }

    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    .label {
        font-weight: bold;
        color: hsla(190, 99%, 30%, 1);
        font-size: 15px;
    }

    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
        border-radius: 7px;
    }

    .value {
        font-size: 17px;
    }

    .inner-box {
        padding-top: 1rem;
        border: 2px solid hsla(190, 99%, 30%, 1);
        margin: 6px;
        border-radius: 7px;
    }

    .v-data-table tbody tr td {
        border: none !important;
    }

    .table-data {
        margin: 8px;
    }

    .time>>>.v-input__slot {
        width: 10rem;
    }

    .abstud {
        text-decoration: underline;
    }

    .textcolor {
        color: orange;
    }

    .eye {
        font-size: 30px;
        cursor: pointer;
    }

    .card {
        border: 1px solid hsla(190, 99%, 30%, 1) !important;
    }

    .theme--light.v-data-table thead tr th {
        color: white;
        background-color: hsla(190, 99%, 30%, 1) !important;
        font-weight: bold;
    }

    .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }

    .time-btn {
        height: 2rem;
        background-color: red;
        padding: 2px;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .v-progress-circular {
        margin: 1rem;
    }

    .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
</style>